import API from "../../api";

export const getNavigation = parentId => {
  return API.surety().get(`/agent-manuals/table-of-contents/${parentId}`);
};

export const getContent = contentId => {
  return API.surety().get(`/agent-manuals/content/${contentId}`);
};
